import { Component, Input } from '@angular/core';
import { Injectable } from '@angular/core';
import { Stormpath, LoginService } from '../stormpath/stormpath.service';
export var AuthPortComponent = (function () {
    function AuthPortComponent(stormpath, loginService) {
        this.stormpath = stormpath;
        this.loginService = loginService;
        this.user$ = this.stormpath.user$;
        this.loggedIn$ = this.user$.map(function (user) { return !!user; });
    }
    AuthPortComponent.prototype.ngOnInit = function () {
        this.loginService.login = true;
        this.loginService.register = false;
        this.forgot = this.loginService.forgot;
        this.user$ = this.stormpath.user$;
        this.loggedIn$ = this.user$.map(function (user) { return !!user; });
    };
    AuthPortComponent.prototype.showLogin = function () {
        this.loginService.login = !(this.loginService.forgot = this.loginService.register = false);
    };
    AuthPortComponent.prototype.showRegister = function () {
        this.loginService.forgot = this.loginService.login = false;
        this.loginService.register = true;
    };
    AuthPortComponent.prototype.forgotPassword = function () {
        this.loginService.login = false;
        this.forgot = true;
    };
    AuthPortComponent.prototype.logout = function () {
        this.stormpath.logout();
    };
    AuthPortComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sp-authport',
                    template: "<template #defaultTemplate>\n  <div class=\"container\">\n    <div class=\"row\" *ngIf=\"(user$ | async) === false\">\n      <div class=\"col-xs-12 col-sm-offset-3 col-sm-6\">\n        <div class=\"panel panel-default\">\n          <div class=\"panel-heading\">\n            <h4>\n              <ul class=\"nav nav-pills\">\n                <li role=\"presentation\" [ngClass]=\"{active:loginService.login || loginService.forgot}\" id=\"login\">\n                  <a href=\"\" (click)=\"showLogin(); false\">Sign In</a>\n                </li>\n                <li role=\"presentation\" [ngClass]=\"{active:loginService.register}\" id=\"register\" class=\"pull-right\">\n                  <a href=\"\" (click)=\"showRegister(); false\">Register</a>\n                </li>\n              </ul>\n            </h4>\n          </div>\n          <div class=\"panel-body text-center\">\n            <div class=\"row\" *ngIf=\"loginService.forgot\">\n              <forgot-password-form></forgot-password-form>\n            </div>\n            <div class=\"row\" *ngIf=\"loginService.login\">\n              <div class=\"col-xs-12\">\n                <login-form></login-form>\n              </div>\n            </div>\n            <div class=\"row\" *ngIf=\"loginService.register\">\n              <div class=\"col-xs-12\">\n                <register-form autoLogin=true></register-form>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n<template\n  [ngTemplateOutlet]=\"customTemplate || defaultTemplate\">\n</template>",
                    providers: [LoginService]
                },] },
        { type: Injectable },
    ];
    /** @nocollapse */
    AuthPortComponent.ctorParameters = function () { return [
        { type: Stormpath, },
        { type: LoginService, },
    ]; };
    AuthPortComponent.propDecorators = {
        'customTemplate': [{ type: Input },],
    };
    return AuthPortComponent;
}());
//# sourceMappingURL=authport.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-stormpath/dist/esm/src/authport/authport.component.js
// module id = 566
// module chunks = 0